<section id="contact" class="relative py-24 sm:py-32 bg-surface">
  <div class="absolute inset-0 -z-10">
    <div class="absolute top-0 left-1/3 w-80 h-80 bg-accent/3 blur-3xl rounded-full"></div>
  </div>
  <div class="container mx-auto px-6 lg:px-10">
    <!-- Section header -->
    <div class="flex items-center gap-4 mb-14" data-aos="fade-up" data-aos-delay="100">
      <span class="font-mono text-[10px] text-accent/40 tracking-widest select-none">///</span>
      <span class="text-accent font-mono text-sm">07</span>
      <h2 class="text-3xl sm:text-4xl font-display font-black text-text-strong">
        {{ "contact.title" | translate }}
      </h2>
      <span class="flex-1 h-px bg-subtle"></span>
    </div>

    <div class="grid grid-cols-1 lg:grid-cols-[minmax(0,1fr)_minmax(0,1.2fr)] gap-12">
      <!-- Left: CTA + social links -->
      <div data-aos="fade-up" data-aos-delay="200">
        <p class="text-lg text-muted-light leading-relaxed mb-8">
          {{ "contact.description" | translate }}
        </p>
        <div class="space-y-4">
          <a href="mailto:contact.vnribeiro@gmail.com"
            class="flex items-center gap-3 text-sm text-muted-light hover:text-accent transition-colors">
            <span class="w-10 h-10 rounded-lg border border-subtle flex items-center justify-center text-muted">
              <i class="fas fa-envelope text-sm"></i>
            </span>
            contact.vnribeiro&#64;gmail.com
          </a>
          <a href="https://linkedin.com/in/vinicius-costa-azevedo-ribeiro" target="_blank" rel="noopener noreferrer"
            class="flex items-center gap-3 text-sm text-muted-light hover:text-accent transition-colors">
            <span class="w-10 h-10 rounded-lg border border-subtle flex items-center justify-center text-muted">
              <i class="fab fa-linkedin text-sm"></i>
            </span>
            LinkedIn
          </a>
          <a href="https://github.com/vnribeiro" target="_blank" rel="noopener noreferrer"
            class="flex items-center gap-3 text-sm text-muted-light hover:text-accent transition-colors">
            <span class="w-10 h-10 rounded-lg border border-subtle flex items-center justify-center text-muted">
              <i class="fab fa-github text-sm"></i>
            </span>
            GitHub
          </a>
        </div>
      </div>

      <!-- Right: Form -->
      <div class="bg-surface-100/60 border border-subtle p-8 sm:p-10 rounded-xl" data-aos="zoom-in-up" data-aos-delay="200">
        <form [formGroup]="contactForm" (ngSubmit)="onSubmit()" aria-label="Contact Form" class="space-y-5">
          <div class="grid grid-cols-1 md:grid-cols-2 gap-5">
            <div>
              <label for="name" class="block text-[10px] font-mono uppercase tracking-[0.2em] text-muted mb-2">{{ "contact.form.labels.name" | translate }}</label>
              <input type="text" id="name" formControlName="name" autocomplete="name" [placeholder]="'contact.form.placeholder.name' | translate" required maxlength="50" aria-required="true" aria-label="name" [attr.aria-invalid]="displayMessage['name'] ? 'true' : null"
                class="block w-full px-4 py-3 bg-surface-200/60 border border-subtle rounded text-text placeholder-muted-dark font-mono text-sm focus:outline-none focus:border-accent focus:ring-1 focus:ring-accent/30 transition-colors">
              @if (displayMessage['name']) {
                <span class="text-danger mt-1.5 block text-xs font-mono" aria-live="assertive">{{ displayMessage['name'] | translate }}</span>
              }
            </div>
            <div>
              <label for="email" class="block text-[10px] font-mono uppercase tracking-[0.2em] text-muted mb-2">{{ "contact.form.labels.email" | translate }}</label>
              <input type="email" id="email" formControlName="email" autocomplete="email" [placeholder]="'contact.form.placeholder.email' | translate" required aria-required="true" aria-label="email" [attr.aria-invalid]="displayMessage['email'] ? 'true' : null"
                class="block w-full px-4 py-3 bg-surface-200/60 border border-subtle rounded text-text placeholder-muted-dark font-mono text-sm focus:outline-none focus:border-accent focus:ring-1 focus:ring-accent/30 transition-colors">
              @if (displayMessage['email']) {
                <span class="text-danger mt-1.5 block text-xs font-mono" aria-live="assertive">{{ displayMessage['email'] | translate }}</span>
              }
            </div>
          </div>
          <div>
            <label for="subject" class="block text-[10px] font-mono uppercase tracking-[0.2em] text-muted mb-2">{{ "contact.form.labels.subject" | translate }}</label>
            <input type="text" id="subject" formControlName="subject" [placeholder]="'contact.form.placeholder.subject' | translate" required maxlength="50" aria-required="true" aria-label="subject" [attr.aria-invalid]="displayMessage['subject'] ? 'true' : null"
              class="block w-full px-4 py-3 bg-surface-200/60 border border-subtle rounded text-text placeholder-muted-dark font-mono text-sm focus:outline-none focus:border-accent focus:ring-1 focus:ring-accent/30 transition-colors">
            @if (displayMessage['subject']) {
              <span class="text-danger mt-1.5 block text-xs font-mono" aria-live="assertive">{{ displayMessage['subject'] | translate }}</span>
            }
          </div>
          <div>
            <label for="message" class="block text-[10px] font-mono uppercase tracking-[0.2em] text-muted mb-2">{{ "contact.form.labels.message" | translate }}</label>
            <textarea id="message" formControlName="message" [placeholder]="'contact.form.placeholder.message' | translate" required maxlength="500" aria-required="true" aria-label="message" aria-describedby="message-helper" [attr.aria-invalid]="displayMessage['message'] ? 'true' : null" rows="5"
              class="block w-full px-4 py-3 bg-surface-200/60 border border-subtle rounded text-text placeholder-muted-dark font-mono text-sm focus:outline-none focus:border-accent focus:ring-1 focus:ring-accent/30 transition-colors resize-none"></textarea>
            <span id="message-helper" class="mt-1.5 block text-[10px] text-muted font-mono">{{ "contact.form.helper.message" | translate }}</span>
            @if (displayMessage['message']) {
              <span class="text-danger mt-1 block text-xs font-mono" aria-live="assertive">{{ displayMessage['message'] | translate }}</span>
            }
          </div>
          <div class="pt-2">
            <button type="submit"
              [ngClass]="{
                  'bg-muted-dark text-muted-light cursor-not-allowed': contactForm.invalid,
                  'bg-accent-dim hover:bg-accent text-text-inverse cursor-pointer': !contactForm.invalid && !isSubmitting,
                  'bg-accent-dim text-text-inverse': isSubmitting,
                  'cursor-not-allowed': isSubmitting
                }" [disabled]="contactForm.invalid || isSubmitting"
              class="w-full transition-all duration-300 font-display font-bold py-3 px-8 rounded text-sm tracking-wide disabled:cursor-not-allowed">
              @if (isSubmitting) {
                <i class="fas fa-spinner fa-spin mr-2"></i>
                {{ 'contact.form.sending' | translate }}
              } @else {
                {{ 'contact.form.button' | translate }}
              }
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</section>
